import { useAuthContext } from '../../../context/AuthContext';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { adminBadge, adminHeaderBar } from '../adminStyles';

const pageTitles: Record<string, string> = {
  '/admin': 'ダッシュボード',
  '/admin/': 'ダッシュボード',
  '/admin/item': '商品管理',
  '/admin/item/': '商品管理',
  '/admin/store/show': '店舗情報',
  '/admin/store/plan-items': 'プラン商品',
  '/admin/store/tweet': 'つぶやき',
  '/admin/store/report': 'レポート',
};

const getPageTitle = (pathname: string): string => {
  if (pageTitles[pathname]) {
    return pageTitles[pathname];
  }

  if (pathname.startsWith('/admin/store/report')) {
    return 'レポート';
  }

  return '管理画面';
};

const AdminHeader = () => {
  const { store } = useAuthContext();
  const location = useLocation();
  const pageTitle = getPageTitle(location.pathname);

  return (
    <header className={`${adminHeaderBar} hidden md:flex`}>
      <div>
        <p className="mb-1 text-xs font-medium uppercase tracking-[0.18em] text-teal-600">Store Admin</p>
        <h2 className="text-lg sm:text-xl font-medium text-stone-800">{pageTitle}</h2>
      </div>
      {store?.name && (
        <span className={`${adminBadge} max-w-[16rem] truncate`}>{store.name} 様</span>
      )}
    </header>
  );
};

export default AdminHeader;
